import { errorEntryType, getCode } from "@/core/api";

import { IRenderer } from "./types";

const EXCEEDED_FILE_SIZE = "EXCEEDED_FILE_SIZE";
const BAD_CONTENT_TYPE = "BAD_CONTENT_TYPE";
const NO_FILE_CONTENT = "NO_FILE_CONTENT";

const FILE_TOO_BIG = "FILE_TOO_BIG";
const FILE_BAD_CONTENT_TYPE = "FILE_BAD_CONTENT_TYPE";
const FILE_EMPTY = "FILE_EMPTY";

export const errorKey = (error?: IRenderer["error"]) => {
  if (!error) {
    return "";
  }

  if (!error.payload) {
    return "";
  }

  if (error.status === 413) {
    return FILE_TOO_BIG;
  }

  if (error.status === 415) {
    return FILE_BAD_CONTENT_TYPE;
  }

  const payload = errorEntryType(error.payload);
  const code = getCode(payload);

  switch (code) {
    case EXCEEDED_FILE_SIZE: {
      return FILE_TOO_BIG;
    }
    case BAD_CONTENT_TYPE: {
      return FILE_BAD_CONTENT_TYPE;
    }
    case NO_FILE_CONTENT: {
      return FILE_EMPTY;
    }
    default: {
      return "GENERAL";
    }
  }
};
